<scu-title-header>{{ 'case-description.description' | translate }}</scu-title-header>

<scu-text-area [control]="description" [maxLength]="textMax" placeholder="{{'case-description.placeholder' | translate}}"
               [error]='description.errors?.["minlength"]' [dataTest]="dataTestId"></scu-text-area>

